// extracted by mini-css-extract-plugin
export var aniSpin = "C_d";
export var el = "C_b";
export var item = "C_q";
export var navigate = "C_5";
export var wrapper = "C_4";